







































































































import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

// Models
import BeaconModel from '@/_models/BeaconModel'
import CardModel from '@/_models/CardModel'
import UserModel from '@/_models/UserModel'

// Mixins
import TableSortMixin from '@/components/mixins/TableSortMixin.vue'
import IndoorOutdoorMixin from '@/components/mixins/IndoorOutdoorMixin.vue'

import UserSearchListTable from '@/components/user/UserSearchListTable.vue'
import FloorBuildingFilterFrom from '@/components/common/indoor-outdoor/FloorBuildingFilterFrom.vue'

// Utils
import { alertUserChangeLocation } from '@/_utils/card-alert'

// Filter
import { Filter } from '@/_utils/filter'
import _ from 'lodash'

// Partials
import DripNaviPane from './partials/DripNaviPane/index.vue'
import { Constant } from '@/_services/constant'

interface FixedDeviceIndoorModel {
  _id: string
  thingsColor: string
  peopleColor: string
  countNavi: number
  countThings: number
  countPeople: number
  usernames: string
  users: UserModel[]
  left: string
  top: string
  transform: string
  isSelected: boolean
  fixed_id: string
}

@Component({
  components: {
    UserSearchListTable,
    FloorBuildingFilterFrom,
    DripNaviPane,
  },
  computed: {},
})
export default class IndoorNoGmapDisplay extends mixins(TableSortMixin, IndoorOutdoorMixin) {
  selectedMode: string = 'indoor'
  filterUtilTableSort: any = new Filter('filter_indoor_table_sort')
  filterUtilInOutdoorTable: any = new Filter('filter_user_search_page_202011')

  floorMapContainerHeight: number = 0
  pinMarkersIndoor: any[] = []
  mapContainerContentWidth: string = 'initial'

  get isLoadingUsers(): boolean {
    return this.$store.state.users.loading
  }

  get floorMapEle(): any {
    return document.getElementById('floorMap')
  }

  get tableUsersEle(): any {
    return document.getElementById('tableUsers')
  }

  get floorMapFileEle(): any {
    return document.getElementById('floorMapFile')
  }

  onMapLoaded() {
    const floorMapFileEl = this.$refs.floorMapFile as any
    const documentHeight = window.innerHeight
    if (floorMapFileEl && document.body.offsetHeight && documentHeight) {
      this.mapContainerContentWidth =
        ((documentHeight - 200) / floorMapFileEl.offsetHeight) * floorMapFileEl.offsetWidth + 'px'
    }
  }

  get ne(): any {
    const sw = this.latlngToXY(this.selectedFloor.floor_sw_lat, this.selectedFloor.floor_sw_lon)
    return this.latlngToXY(this.selectedFloor.floor_ne_lat, this.selectedFloor.floor_ne_lon)
  }

  get sw(): any {
    return this.latlngToXY(this.selectedFloor.floor_sw_lat, this.selectedFloor.floor_sw_lon)
  }

  get heightBoundingImg(): number {
    const sw = this.sw
    const ne = this.ne
    const w = ne.x - sw.x
    const h = sw.y - ne.y

    return (h / w) * 100
  }

  @Watch('selectedMode')
  selectedModeChange(mode) {
    this.$router.push({ name: mode }).catch(error => false)
  }

  @Watch('users')
  async usersChanged(newList, oldList) {
    alertUserChangeLocation(this, newList, oldList)
  }

  @Watch('selectedFloor')
  async displayMap() {
    if (!this.canDisplayMap || this._isDestroyed) {
      return
    }

    const floorMapEle = this.floorMapEle
    if (floorMapEle) {
      floorMapEle.style.transform = 'rotate(-' + this.selectedFloor.floor_angle + 'deg)'
    }
    const floorMapFileEle = this.floorMapFileEle
    if (floorMapFileEle) {
      floorMapFileEle.style.transform = 'rotate(' + this.selectedFloor.floor_angle + 'deg)'
    }

    this.$store.dispatch('users/getAll').then(() => {
      if (this._isDestroyed) {
        return
      }
      this.setFixedDevicesIndoor()
      this.refreshUsersInFloor()
    })
  }

  @Watch('selectedBuildingName')
  async selectedBuildingNameChanged(newVal, oldVal) {
    if (oldVal !== '') {
      this.searchQueryFloor = ''
    }
  }

  getPinHtmlId(fixedDevice: BeaconModel | CardModel): string {
    return 'pin-' + fixedDevice._id
  }

  isSelectedPin(pin: FixedDeviceIndoorModel) {
    return this.isSelectedByUsersAndCheckedRow(pin.users)
  }

  isMixedPins(pin: FixedDeviceIndoorModel) {
    return pin.countPeople > 0 && (pin.countThings > 0 || pin.countNavi > 0)
  }

  displayMakers() {
    return this.$nextTick(() => {
      this.setFixedDevicesIndoor()
    })
  }

  setFixedDevicesIndoor() {
    const fixedDevices = this.fixedDevices.filter((fixedDevice: BeaconModel | CardModel): boolean => {
      return fixedDevice.floor_id === this.selectedFloor._id
    })

    const pinMarkersIndoor: FixedDeviceIndoorModel[] = []
    fixedDevices.map(fixedDevice => {
      const users = this.usersNearestFixedDevice(fixedDevice)
      const coma = ', '
      const usernames = users
        .map(user => {
          return user.name
        })
        .join(coma)

      const sw = this.sw
      const ne = this.ne
      const w = ne.x - sw.x
      const h = sw.y - ne.y
      const beaconXY = this.latlngToXY(fixedDevice.lat, fixedDevice.lon)
      const beaconLeft = beaconXY.x - sw.x
      const beaconTop = beaconXY.y - ne.y

      const things = users.filter(user => user.user_type === 'things')
      const peoples = users.filter(user => user.user_type === 'people')
      const navis = users.filter(user => user.user_type === Constant.NAVI_USER_TYPE)
      const thingsColor = things.length === 1 ? things[0].category_color.toLowerCase().replace('#', '') : ''
      const peopleColor = peoples.length === 1 ? peoples[0].category_color.toLowerCase().replace('#', '') : ''

      const marker: FixedDeviceIndoorModel = {
        _id: fixedDevice._id,
        users,
        thingsColor,
        peopleColor,
        countThings: things.length,
        countPeople: peoples.length,
        countNavi: navis.length,
        usernames,
        left: (beaconLeft * 100) / w + '%',
        top: (beaconTop * 100) / h + '%',
        transform: 'rotate(' + this.selectedFloor.floor_angle + 'deg)',
        isSelected: false,
        fixed_id: fixedDevice._id,
      }

      pinMarkersIndoor.push({
        ...marker,
        isSelected: this.isSelectedByUsersAndCheckedRow(users),
      })
    })

    this.pinMarkersIndoor = pinMarkersIndoor
  }

  gotoUserRoute(userId: string): void {
    if (this.$route.params.user_id !== userId) {
      this.$router
        .push({
          name: 'indoor_nogmap',
          params: { user_id: userId },
        })
        .catch(error => false)
    }
  }

  latlngToXY(lat: number, lon: number): any {
    let siny: number = Math.sin((lat * Math.PI) / 180)
    siny = Math.min(Math.max(siny, -0.9999), 0.9999)

    return {
      x: 0.5 + lon / 360,
      y: 0.5 - Math.log((1 + siny) / (1 - siny)) / (4 * Math.PI),
    }
  }

  usersNearestFixedDevice(fixedDevice: BeaconModel | CardModel): UserModel[] {
    if (!this.filteredUsers?.length && !this.naviItems?.length) {
      return []
    }

    const users: UserModel[] = []
    for (const user of this.filteredUsers) {
      const isNearest = user.nearest_beacon_id === fixedDevice._id || user.nearest_card_id === fixedDevice._id

      if (!this.isCardOff(user) && !this.isGPSMode(user) && isNearest) {
        users.push(user)
      }
    }

    // Navi Users
    for (const naviItem of this.naviItems) {
      const isNearest = naviItem.san_id === (fixedDevice as CardModel).san_id
      if (!isNearest) {
        continue
      }
      const user = new UserModel()
      user._id = naviItem.user_id
      user.name = naviItem.user_id
      user.error_message = naviItem.error_message
      user.user_type = Constant.NAVI_USER_TYPE
      users.push(user)
    }

    return users
  }

  onFixedPinClicked(pin: FixedDeviceIndoorModel): void {
    this.handlePinClick(pin)
    if (pin.countPeople + pin.countThings > 0 && this.tableUsersEle) {
      this.tableUsersEle.scrollIntoView()
    }
  }

  // After page created
  async created() {
    this.pageFilters = this.filterUtilInOutdoorTable.get(this.pageFilters)

    await this.$store.dispatch('settings/getFromLocal')

    await this.$store.dispatch('cards/getAll', { card_type: 'all' })
    await this.$store.dispatch('beacons/getAll')

    this.$store.dispatch('floors/getAll').then(async () => {
      this.checkAndChangeFloor()
    })
  }

  updated() {
    this.floorMapContainerHeight = (this.$refs?.floorMapFile as any)?.offsetHeight
  }

  beforeDestroy() {
    this._isDestroyed = true
    this.$store.dispatch('users/clearSetTimeOut')
    clearTimeout(this.refreshTimer)
  }
}
